/**
 * Header
 */
const componentStickyHeader = (args) => {

  let header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      setTimeout(() => {
        if (window.scrollY > 50) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }, 250);
    });
  }

  // make the call chainable
  return this;

};

componentStickyHeader();

/**
 * Toggle search form and focus input
 */
document.addEventListener('DOMContentLoaded', function() {

  const searchToggles = document.querySelectorAll('.js-search-toggle');
  const siteHeader = document.querySelector('.site-header');

  const searchInput = siteHeader.querySelector('.search-form__input');
  const siteHeaderSearch = siteHeader.querySelector('.site-header__search');
  const searchFormChildren = siteHeaderSearch.querySelectorAll('input, button');
  const siteHeaderMain = siteHeader.querySelector('.site-header__main');

  // Set tabindex="-1" for child elements initially
  searchFormChildren.forEach(child => child.setAttribute('tabindex', '-1'));

  searchToggles.forEach(searchToggle => {
    searchToggle.addEventListener('click', function() {

      siteHeader.classList.toggle('search-active');
      if (siteHeader.classList.contains('search-active')) {
        searchInput.focus();
        searchFormChildren.forEach(child => child.setAttribute('tabindex', '0'));
        setTimeout(() => {
          siteHeaderMain.style.display = 'none';
        }, 350);
      } else {
        searchInput.blur();
        searchFormChildren.forEach(child => child.setAttribute('tabindex', '-1'));
        siteHeaderMain.style.display = 'flex';
      }
    });
  });
});
